/**
 * Created by Sergey Shoshin on 2017-04-09.
 */
export default class ApiError {
    public status: number;
    public message: string;
    public errors: Error;
}

export class Error {
    public error: [string];
}


// WEBPACK FOOTER //
// ./src/app/models/api-error.ts